import { render } from "./Indikace.vue?vue&type=template&id=5676fcb6"
import script from "./Indikace.vue?vue&type=script&lang=js"
export * from "./Indikace.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__